// 32ecc37db61fa70464333dd9db4b756d8a985b28|className=CompanyTypeApi|type=angular|apiName=entity|apiEnumKey=Entity|operationHash=a51fd341fa3ac0bf0a6809948d1b45f62ae3af38|kind=api-js

import * as i0 from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Api } from '@myre/common-conf';
import {
  DynamicEnvService,
  AngularSdk,
} from '@myre/ui-domain-http';
import { parseOkResponseFromJSON } from '../../../parsers/OkResponse';

import { parseCompanyTypeFromJSON } from '../../../parsers/CompanyType';

export class CompanyTypeApi extends AngularSdk {
  constructor(
    dynamicEnvService,
    httpClient,
  ) {
    super(dynamicEnvService, httpClient);
  }

  /**
   * @tags CompanyTypeApi
   * @name CompanyTypeApiGetCompanyTypes
   * @summary Get all company types
   * @request GET:/company-types
   */
  getCompanyTypes(
    requestOptions = {},
  ) {
    return this._request(
      {
        path: `/company-types`,
        method: 'GET',
        api: Api.Entity,
      },
      {
        ...requestOptions,
        parser: data => parseOkResponseFromJSON(data, {
    contentParser: parseCompanyTypeFromJSON,
    isContentArray: true,
  }),
      },
    );
  }

  static ɵfac = function CompanyTypeApi_Factory(t) { return new (t || CompanyTypeApi)(i0.inject(DynamicEnvService), i0.inject(HttpClient)); };
  static ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({ token: CompanyTypeApi, factory: CompanyTypeApi.ɵfac, providedIn: 'root' });
}
